import { defaultsDeep } from 'lodash';
import $ from 'jquery';
import { generateUUID } from '@mode/shared/util-js';

export interface FormConfig {
  method?: string;
  target?: string;
  fields?: { [k: string]: string };
}

/**
 * Dynamically generate, mount and submit webform
 *
 * @param {string} actionUrl
 * @param {{method: string}} config
 */
export function formSubmit(actionUrl: string, config: FormConfig = {}): void {
  // well-known browser API for parsing URLs, with fix for IE bug for relative URLs https://stackoverflow.com/a/13405933/362030
  const a = document.createElement('a');
  a.href = actionUrl;
  // eslint-disable-next-line no-self-assign
  a.href = a.href; // fix for IE bug

  const actionOrigin = `${a.protocol}//${a.host}`;
  const origin = `${location.protocol}//${location.host}`;
  if (actionOrigin !== origin) {
    console.error(
      `Cross-origin form submit blocked, could reveal CSRF token to an attacker.\nForm submit URL: ${actionUrl}\nOur origin: ${origin}`
    );
    return;
  }

  const settings: FormConfig = defaultsDeep(config, {
    method: 'post',
    target: '_self',
    fields: {
      // this emulates the utf8 check-mark hidden input
      // that the rails form_tag helper typically provides
      // to prevent an IE<=8 bug
      // @see https://stackoverflow.com/a/3348524
      utf8: '\u2713',
    },
  });
  const $form = $(`<form />`, {
    'accept-charset': 'UTF-8',
    role: 'form',
    id: generateUUID(),
    action: actionUrl,
    method: settings.method,
    target: settings.target,
  });

  for (const key in settings.fields) {
    $('<input>')
      .attr({
        type: 'hidden',
        name: key,
        value: settings.fields[key],
        autocomplete: 'off',
      })
      .appendTo($form);
  }
  $form.appendTo('body').submit();
}
